// WhatsAppContext.jsx
import React, { createContext, useContext, useState } from 'react';
import ConditionalWhatsAppButton from '../components/ConditionalWhatsAppButton';

const WhatsAppContext = createContext();

export const WhatsAppProvider = ({ children }) => {
  const [whatsappConfig, setWhatsappConfig] = useState({
    phoneNumber: "+96893579571",
    message: "Hello, I would like to contact you!"
  });

  return (
    <WhatsAppContext.Provider value={{ whatsappConfig, setWhatsappConfig }}>
      {children}
      <ConditionalWhatsAppButton />
    </WhatsAppContext.Provider>
  );
};

export const useWhatsApp = () => useContext(WhatsAppContext);